/**
 * The one honest sentence a client-side sort owes the reader.
 *
 * The customer and location money tabs fetch a capped page (200 rows) but
 * print the server's real `total` in the tab badge — Cintas shows ~3,030
 * invoices. Sorting happens in the browser, over the rows that actually
 * arrived. So "sort by Total, biggest first" answers "the biggest of the
 * 200 most recent", which is NOT the question the office asked, and
 * nothing on screen would have said so.
 *
 * Renders nothing when everything is loaded, which is the normal case.
 */
export function SortScopeNote({
    loaded,
    total,
    noun,
    which = "the most recent",
    hint = "Search or change the status filter to bring the rest into range.",
}: {
    loaded: number;
    total: number | undefined;
    noun: string;
    /** Which rows the server sent, e.g. "the soonest to lapse". Defaults to newest-first lists. */
    which?: string;
    /** What to do about the rest; pass "" on a page with no search or filter. */
    hint?: string;
}) {
    if (total === undefined || total <= loaded) return null;
    return (
        <p className="mt-2 text-xs text-foreground/70">
            Sorting covers the {loaded.toLocaleString()} {noun} loaded here — {which} of {total.toLocaleString()}.
            {hint && ` ${hint}`}
        </p>
    );
}
